import React from 'react'

import TriangleImage from 'components/shared/TriangleImage'
import Layout from 'components/shared/Layout'
import Image from 'components/shared/Image'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const SectionHeaderWithTriangleImage = ({
  className,
  children,
  triangleImage,
  position = 'top-left',
}) => {
  return (
    <Layout type="maxWidth" className={cx(className, position)}>
      {triangleImage && (
        <div className={css.triangleImageWrapper}>
          <TriangleImage
            className={css.triangleImage}
            type={position}
            {...triangleImage}
          />
          <Image
            src="/assets/decoration.svg"
            media={{ width: 162, height: 161 }}
            className={css.decoration}
            alt=""
          />
        </div>
      )}
      {children}
    </Layout>
  )
}

SectionHeaderWithTriangleImage.defaultProps = {}

export default SectionHeaderWithTriangleImage
